import React, { useRef, useState } from "react";
import "./style.scss";

// Anti-spam protection for public forms. Renders a hidden "honeypot" input
// that only bots fill in and tracks how long the form was open. Backend
// silently drops submissions that fail these checks (see common/antispam.py).
function useBotTrap() {
  const openedAt = useRef(Date.now());
  const [website, setWebsite] = useState("");

  const field = (
    <div className="Bot-Trap" aria-hidden="true">
      <label>
        Website
        <input
          type="text"
          name="website"
          tabIndex={-1}
          autoComplete="off"
          value={website}
          onChange={(e) => setWebsite(e.target.value)}
        />
      </label>
    </div>
  );

  const getData = () => ({
    website: website,
    form_elapsed: Date.now() - openedAt.current,
  });

  return [field, getData];
}

export default useBotTrap;
